/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-08-08 13:42:37
 * @LastEditTime : 2022-08-08 13:44:31
 * @LastEditors  : yangxr
 * @Description  : 版本管理
 * @FilePath     : \icps_fb\src\api\basedata\versionMan.js
 */
import request from '@/utils/request'
export const Download = "/base/system/params/export";

// 获取版本数据
export function getVersionList(params) {
  return request({
    url: '/base/system/bnesspublog/query_page',
    method: 'post',
    data: params
  })
}
// 新增、编辑系统参数
export function saveOrUpdate(params) {
  return request({
    url: '/base/system/bnesspublog/save_or_update',
    method: 'post',
    data: params
  })
}

